/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomEmailSettings200ResponseSettingsOauth2Auth
 */
export interface GetCustomEmailSettings200ResponseSettingsOauth2Auth {
    /**
     * 
     */
    tenantId?: string;
    /**
     * 
     */
    clientId: string;
    /**
     * 
     */
    clientSecret: string;
    /**
     * 
     */
    tokenUrl?: string;
    /**
     * 
     */
    scope?: string;
    /**
     * 
     */
    accessToken?: string;
}

/**
 * Check if a given object implements the GetCustomEmailSettings200ResponseSettingsOauth2Auth interface.
 */
export function instanceOfGetCustomEmailSettings200ResponseSettingsOauth2Auth(value: object): value is GetCustomEmailSettings200ResponseSettingsOauth2Auth {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    return true;
}

export function GetCustomEmailSettings200ResponseSettingsOauth2AuthFromJSON(json: any): GetCustomEmailSettings200ResponseSettingsOauth2Auth {
    return GetCustomEmailSettings200ResponseSettingsOauth2AuthFromJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseSettingsOauth2AuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomEmailSettings200ResponseSettingsOauth2Auth {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'],
        'tokenUrl': json['tokenUrl'] == null ? undefined : json['tokenUrl'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
    };
}

export function GetCustomEmailSettings200ResponseSettingsOauth2AuthToJSON(json: any): GetCustomEmailSettings200ResponseSettingsOauth2Auth {
    return GetCustomEmailSettings200ResponseSettingsOauth2AuthToJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseSettingsOauth2AuthToJSONTyped(value?: GetCustomEmailSettings200ResponseSettingsOauth2Auth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'tokenUrl': value['tokenUrl'],
        'scope': value['scope'],
        'accessToken': value['accessToken'],
    };
}

